import config from '../../config'
import { authHeader } from '../utils/auth-header'

export const eventService = {
  getAll, getOne, insertOne, deleteMany, updateOne
}

async function getAll () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let results = await fetch(`${config.apiUrl}/event?_limit=2000`, requestOptions)
  results = await results.json()

  let sports = await fetch(`${config.apiUrl}/graphql?query={ sports{name,_id} }`, requestOptions)
  sports = await sports.json()
  let sportsArray = {}
  for (const sport of sports.data.sports) {
    sportsArray[sport._id] = sport
  }
  for (const result of results) {
    result.competition.sport = sportsArray[result.competition.sport]
  }

  return { data: { events: results } }
}

async function getOne (id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  let result = await fetch(`${config.apiUrl}/graphql?query={ event(id:"${id}"){ name, _id, date_start, date_end, competition { name, _id, sport {name, _id} } parent_event { name, _id, date_start, date_end } child_events { name, _id, date_start, date_end, fixtures { _id, fixtureteams { _id } } child_events{ _id, fixtures { _id, fixtureteams { _id } } child_events{ _id, fixtures { _id, fixtureteams { _id } } child_events{ _id, fixtures { _id } } } } } fixtures { name, _id, date_start, fixtureteams { _id } } } }`, requestOptions)
  result = await result.json()

  return result
}

async function insertOne (event) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    body: JSON.stringify(event)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/event`, requestOptions)
  result = await result.json()
  return result
}

async function deleteMany (eventIds) {
  let requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }

  for (let eventId of eventIds) {
    await fetch(`${config.apiUrl}/event/${eventId}`, requestOptions)
  }

  return 'OK'
}

async function updateOne (event) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    body: JSON.stringify(event)
  }
  requestOptions.headers['Content-Type'] = 'application/json; charset=utf-8'

  let result = await fetch(`${config.apiUrl}/event/${event._id}`, requestOptions)
  result = await result.json()

  return result
}



// WEBPACK FOOTER //
// ./src/services/event.js